import './record-edit-menu.scss'

import { faCheck, faTabletAlt, faTimes, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import Component from 'vue-class-component';

import { OfflineDataFetcher } from '@skinsoft/data-store';
import { RecordDataStore, RecordLifecycleState, recordSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { SAVE_CURRENT_RECORD_TOPIC, TOGGLE_MENU_TOPIC, TRANSITION_RECORD_TO_STATE } from '../../../../busTopics';

@Component({
    components: {

    },
    props: [''],
    template: require('./record-edit-menu.html')
})
export class RecordEditMenu extends ReactiveVue {

    private get displayLocalWarning() {
        return !this.onLine || (this.recordId && OfflineDataFetcher.isTemporaryId(this.recordId));
    }

    private showValidation = false;
    private recordId: string = ""
    private onLine: boolean = false;
    private running = false;
    private states = ['inProgress', 'toValidated', 'validated']

    private selectedLifecycleState: RecordLifecycleState = null as any;

    private transitionCallback: () => void

    private displayStatuses = false

    // Icons 
    private checkIcon = faCheck;
    private crossIcon = faTimes;
    private warningIcon = faTabletAlt;
    private caretDownIcon = faCaretDown;
    private caretRightIcon = faCaretRight;

    private $recordDataStore: RecordDataStore
    private recordState: string = "";

    public mounted() {
        this.recordId = _.get(this.$route, 'params.recordId')
        this.subscribeTo(
            this.$recordDataStore.fetchOne(this.recordId),
            record => {
                this.recordState = recordSelectors.currentState(record, this.$i18n.locale);
                this.unsubscribeFrom('record-subscription');
            },
            'record-subscription')
    }

    public created() {
        this.running = true;
        this.onFrame();
    }

    public beforeDestroy() {
        this.running = false;
    }

    public saveRecord() {
        this.emitOnBus(SAVE_CURRENT_RECORD_TOPIC)
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private shouldDisplayStateEntry(key: string) {
        return key !== this.recordState;
    }

    private onFrame() {
        this.onLine = window.navigator.onLine;
        if (this.running) {
            requestAnimationFrame(this.onFrame);
        }
    }

    private onStatusClick(state: RecordLifecycleState) {
        this.showValidation = true;
        this.selectedLifecycleState = state;
    }

    private transitionRecordToState() {
        this.emitOnBus(TRANSITION_RECORD_TO_STATE, { state: this.selectedLifecycleState })
    }

    private resetValidation() {
        this.selectedLifecycleState = null as any;
        this.showValidation = false;
    }
}